<template>
	<div class="trun-role">
		<div class="page-handle">
			<div class="left">
				<a-button type="primary" @click="addGroup">添加分组</a-button>
			</div>
			<div class="right">
				<!--<a-input-search @search="onSearch" placeholder="请输入状态标识" style="width: 200px"/>-->
			</div>
		</div>
		<div class="page-content page-turn-content">
			<a-table
					:pagination="false"
					:columns="columns"
					:dataSource="dataGroup"
					:rowKey="record => record.id"
					:loading="loading"
					class="hospital-table"
					size="middle"
			>
				<span slot="number" slot-scope="text,record,index">{{(page-1)*pageSize+index+1}}</span>
				<template slot="groupName" slot-scope="text,record,index">
					<template v-if="record.flag == 1">
						<a-input v-model="record.groupName" type="text" maxlength="20"
						         :class="{'has-error':isSubmit&&!regGroupNames(record.groupName)}" style="width: 260px;"
						         placeholder="请输入组名称"></a-input>
					</template>
					<template v-else-if="record.flag ==2">
						<a-input v-model="record.groupName" type="text" maxlength="20"
						         :class="{'has-error':isSubmit&&!regGroupNames(record.groupName)}" style="width: 260px;"
						         placeholder="请输入组名称"></a-input>
					</template>
					<template v-else>{{record.groupName}}</template>
				</template>
				<template slot="opt" slot-scope="text,record,index">
					<template v-if="record.flag == 1">
						<a href="javascript:;" @click="saveRow(text,record,index)"
						   class="cf-mr10">保存</a>
						<a href="javascript:;" @click="delRow(text,record,index)" class="cf-mr10">删除</a>
					</template>
					<template v-else-if="record.flag == 2">
						<a href="javascript:;" @click="updateRow(text,record,index)"
						   class="cf-mr10">更新</a>
						<a href="javascript:;" @click="cancelRow(text,record,index)"
						   class="cf-mr10">取消</a>
					</template>
					<template v-else>
						<a href="javascript:;" @click="editRow(text,record,index)"
						   class="cf-mr10">编辑</a>
						<a href="javascript:;" v-if="record.status ==1"
						   @click="updateStatus(text,record,index)"
						   class="cf-mr10">禁用</a>
						<a href="javascript:;" v-else @click="updateStatus(text,record,index)"
						   class="cf-mr10">启用</a>
					</template>
				</template>
			</a-table>
		</div>
	</div>
</template>

<script>
  import {regAll, checkNameR} from "../../common/validate";

  const columns = [
    {
      title: "序号",
      scopedSlots: {customRender: "number"}
    },
    {
      title: "名称",
      scopedSlots: {customRender: "groupName"},
      width: '35%'
    },
    {
      title: "创建时间",
      dataIndex: "createTime"
    },
    {
      title: "操作",
      scopedSlots: {customRender: "opt"},
      width: '15%'
    }
  ];
  export default {
    data() {
      return {
        columns,
        dataGroup: [],
        data: [{
          flag: 0,
          id: 1,
          groupName: 'group01',
          createTime: '2020-5-20',
        }],
        count: 2,
        isSubmit: false,
        loading: false,
        groupName: '',
        confirmVisible: false,
        confirmLoadding: false,
        baseData: {},
        page: 1,
        pageSize: 10,
        selectData: null,
        visible: false,
        operateStatus: "",
      };
    },
    mounted() {
      this.getGroupList();
    },
    methods: {
      getGroupList() {
        this.dataGroup = [];
        this.loading = true;
        this.$get("patientgroup").then(res => {
          let resData = res.data.data;
          resData.forEach((item, index) => {
            item.flag = 0;
          });
          this.dataGroup = resData;
          this.loading = false;
        });
      },
      addGroup() {
        const {count, dataGroup} = this;
        const newData = {
          id: count,
          flag: 1,
          isSubmit: false,
          groupName: '',
          delFlag: 0,
          createTime: this.$moment(new Date().getTime()).format('YYYY-MM-DD HH:mm:ss'),
        };
        this.dataGroup = [...dataGroup, newData];
        this.count = count + 1;
      },
      delRow(text, record, index) {
        this.dataGroup.splice(index, 1);
      },
      // 校验组名
      regGroupNames(text) {
        if (!text) {
          return false;
        } else if (!regAll.regGroupName.test(text)) {
          return false;
        } else {
          return true;
        }
      },
      saveRow(text, record, index) {
        if (!record.groupName) {
          this.isSubmit = true;
        } else if (!regAll.regGroupName.test(record.groupName)) {
          this.$message.error('不能以数字开头或含有特殊字符的名称！');
          this.isSubmit = true;
        } else {
          let bodyData = Object.assign({}, record);
          bodyData.flag = 0;
          this.$post("patientgroup/add", bodyData, {
            "Content-Type": "application/json"
          }).then(
            res => {
              if (res.data.code == 1) {
                this.$message.success(res.data.message);
                record.flag = 0;
              } else {
                this.$message.error("添加分组失败!");
              }
            },
            error => {
              this.$message.error("添加分组失败!");
            }
          );
        }
      },
      updateStatus(text, record, index) {
        let bodyData = Object.assign({}, record);
        bodyData.status = record.status == 1 ? 0 : 1;
        this.$put("patientgroup/update", bodyData, {
          "Content-Type": "application/json"
        }).then(
          res => {
            if (res.data.code == 1) {
              this.$message.success("操作成功");
              record.flag = 0;
              record.status = bodyData.status;
            } else {
              this.$message.error("操作失败!");
            }
          },
          error => {
            this.$message.error("操作失败!");
          }
        );

      },
      editRow(text, record, index) {
        record["flag"] = 2;
        this.groupName = record.groupName;
        this.data[index] = record;
      },
      cancelRow(text, record, index) {
        let groupName = this.data[index]['groupName'];
        record["flag"] = 0;
        record["groupName"] = this.groupName;
        this.groupName = '';
      },
      updateRow(text, record, index) {
        if (!record.groupName) {
          this.isSubmit = true;
        } else if (!regAll.regGroupName.test(record.groupName)) {
          this.$message.error('不能以数字开头或含有特殊字符的名称！');
          this.isSubmit = true;
        } else {
          let bodyData = Object.assign({}, record);
          bodyData.flag = 0;
          this.$put("patientgroup/update", bodyData, {
            "Content-Type": "application/json"
          }).then(
            res => {
              if (res.data.code == 1) {
                this.$message.success(res.data.message);
                record.flag = 0;
              } else {
                this.$message.error("添加分组失败!");
              }
            },
            error => {
              this.$message.error("添加分组失败!");
            }
          );
        }
      }
    }
  };
</script>

<style lang="scss" scoped>
	.trun-role {
		.pagination {
			padding: 0 30px;
		}
	}
</style>